import { useFeatureFlagValue } from 'shared/src/hooks';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useCallback } from 'react';
import type { GoodsOptionsPricingCoupon } from 'shared/src/api';
import { CouponApplicableType, CouponIssuerType } from 'shared/src/constant';

export const useLogDownloadCoupon = () => {
  const logGoodsAnalyticsEvent = useLogGoodsAnalyticsEvent();
  const enableStackableFlag = useFeatureFlagValue('stackable-coupon');

  return useCallback(
    async (params: {
      coupon: GoodsOptionsPricingCoupon;
      isDownloadAll: boolean;
    }) => {
      logGoodsAnalyticsEvent({
        name: 'COMPLETE_DOWNLOAD_COUPON',
        analytics: {
          POSITION: 'BOTTOM_SHEET',
          IS_DOWNLOAD_ALL: params.isDownloadAll ? '1' : '0',
          ISSUER_TYPE:
            CouponIssuerType[params.coupon.item.issuer_type as 1 | 2],
          APPLICABLE_TYPE:
            CouponApplicableType[params.coupon.item.applicable_type as 1 | 2],
          ENABLE_STACKABLE_COUPON: enableStackableFlag ? '1' : '0',
          COUPON_SNO: params.coupon.item.sno.toString(),
          COUPON_NAME: params.coupon.item.sno,
        },
      });
    },
    [enableStackableFlag, logGoodsAnalyticsEvent],
  );
};
